import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DatatableContextService {
  #contextChangedSubject$ = new Subject<void>();
  contextChanged$ = this.#contextChangedSubject$.asObservable();

  notifyContextChanged() {
    this.#contextChangedSubject$.next();
  }
}
